import {HorizontalBar} from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: ['data'],
  watch: {
    data: function (newVal, oldVal) { // watch it
      this.renderChartData({labels: newVal.labels, datasets: [{data: newVal.data, backgroundColor: '#eb3b5a'}]})
    }
  },
  methods: {
    renderChartData: function (data) {
      let options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          display: false
        },
        scales: {
          yAxes: [{
            display: true,
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          xAxes: [{
            display: false,
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              drawBorder: false,
              display: false
            }
          }
          ]
        }
      }
      this.renderChart(data, options)
    }
  }
}
